/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { Color } from '../../mol-util/color';
import { StructureElement, Bond } from '../../mol-model/structure';
import { ParamDefinition as PD } from '../../mol-util/param-definition';
import { getPaletteParams, getPalette } from '../../mol-util/color/palette';
var DefaultList = 'many-distinct';
var DefaultColor = Color(0xCCCCCC);
var Description = "Assigns a color based on the operator name of a transformed chain.";
export var OperatorNameColorThemeParams = __assign({}, getPaletteParams({
  type: 'colors',
  colorList: DefaultList
}));
export function getOperatorNameColorThemeParams(ctx) {
  var params = PD.clone(OperatorNameColorThemeParams);
  return params;
}

function getOperatorNameSerialMap(structure) {
  var map = new Map();

  for (var i = 0, il = structure.units.length; i < il; ++i) {
    var name_1 = structure.units[i].conformation.operator.name;
    if (!map.has(name_1)) map.set(name_1, map.size);
  }

  return map;
}

export function OperatorNameColorTheme(ctx, props) {
  var color;
  var legend;

  if (ctx.structure) {
    var operatorNameSerialMap_1 = getOperatorNameSerialMap(ctx.structure.root);
    var labelTable_1 = Array.from(operatorNameSerialMap_1.keys());

    var valueLabel = function (i) {
      return labelTable_1[i];
    };

    var palette_1 = getPalette(operatorNameSerialMap_1.size, props, {
      valueLabel: valueLabel
    });
    legend = palette_1.legend;

    color = function (location) {
      var serial = undefined;

      if (StructureElement.Location.is(location)) {
        var name_2 = location.unit.conformation.operator.name;
        serial = operatorNameSerialMap_1.get(name_2);
      } else if (Bond.isLocation(location)) {
        var name_3 = location.aUnit.conformation.operator.name;
        serial = operatorNameSerialMap_1.get(name_3);
      }

      return serial === undefined ? DefaultColor : palette_1.color(serial);
    };
  } else {
    color = function () {
      return DefaultColor;
    };
  }

  return {
    factory: OperatorNameColorTheme,
    granularity: 'instance',
    color: color,
    props: props,
    description: Description,
    legend: legend
  };
}
export var OperatorNameColorThemeProvider = {
  name: 'operator-name',
  label: 'Operator Name',
  category: "Symmetry"
  /* Symmetry */
  ,
  factory: OperatorNameColorTheme,
  getParams: getOperatorNameColorThemeParams,
  defaultValues: PD.getDefaultValues(OperatorNameColorThemeParams),
  isApplicable: function (ctx) {
    return !!ctx.structure;
  }
};